import { EventEmitter } from 'events';

import { TaskService } from './../../services/task.service';

import { Task } from './../../classes/task.class';

export class HomeController extends EventEmitter {
    constructor(params) {
        super();
        this.user = params.user;
        this.taskService = new TaskService({apiUrl: '/api'});

        this.tasks = [];
        
        this.taskService.getTasks(this.user.id).then(res => {
            this.tasks = [];
            this.tasks = res.data.map(task => new Task(task));
            
            this.emitTasks();
                
            }).catch(err => console.log(err));
    }

    getTasks() {
        return this.tasks;
    }

    saveTask() {
        console.log("SAVE");
        this.taskService.postTask({}, this.user).then(res => {
            console.log();

            try {
                let newTask = new Task(res.data);

                this.tasks.push(newTask);

                this.emitTasks();
            }catch(e) {

            }

        });
    }

    updateTask(task) {
        this.taskService.putTask(task, this.user).then(res => {
            console.log(res);

            this.tasks.forEach((task, index) => {
                if(task.id === res.data.id) {
                    this.tasks[index] = new Task(res.data);
                }
            });

            this.emitTasks();
        });
    }

    deleteTask(id) {
        this.taskService.deleteTask(id, this.user).then(res => {
            console.log(res.status);
            console.log(res.status === 200);
            if(res.status === 200) {
                console.log(this.tasks);
                console.log(this.tasks.filter(task => task.id !== id));
                
                this.tasks = this.tasks.filter(task => task.id !== id);
                console.log(this.tasks);
                this.emitTasks();
            }
        });
    }

    emitTasks() {
        this.emit('updateTasks');
    }
}


// WEBPACK FOOTER //
// src/components/home/home.controller.js